import { render, staticRenderFns } from "./refundList.vue?vue&type=template&id=528a7bfe&scoped=true&"
import script from "./refundList.vue?vue&type=script&lang=js&"
export * from "./refundList.vue?vue&type=script&lang=js&"
import style0 from "./refundList.vue?vue&type=style&index=0&id=528a7bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528a7bfe",
  null
  
)

export default component.exports